const translations = {
  "en": {
    "Ask about tokens, trends, people, or profitable moves (and remember to touch grass)": "Ask about tokens, trends, people, or profitable moves (and remember to touch grass)",
    "Connect an account": "Connect an account",
    "Drop the plan or a screenshot, I'll help you read it and spot the catches": "Drop in your plan, a screenshot or anything you want me to double check on.",
    "Second opinion": "Second opinion",
    "Upload a statement": "Upload a statement",
    "Upload holdings screenshot": "Upload holdings screenshot"
  },
  "zh-tw": {
    "Ask about tokens, trends, people, or profitable moves (and remember to touch grass)": "提問關於代幣、趨勢、人物或有利可圖的交易（記得偶爾放鬆一下）",
    "Connect an account": "連結帳戶",
    "Drop the plan or a screenshot, I'll help you read it and spot the catches": "把你的計畫、截圖或任何想讓我二次確認的內容丟進來",
    "Second opinion": "第二意見",
    "Upload a statement": "上傳一份對帳單",
    "Upload holdings screenshot": "上傳持倉截圖"
  }
};

export default translations;
